import { initHelpers } from "./helpers";
//import { initAnimatedHeadings } from "../core/helpers";
import { setOffScreenState } from "../core/helpers";
import { animateIn } from "../core/helpers";
import { initLoader } from "../core/helpers";
import { pageTransitionIn } from "../core/helpers";
import { pageTransitionOut } from "../core/helpers";
import { initWindowInnerheight } from "../core/helpers";
import { initCheckTouchDevice } from "../core/helpers";
import { initCookieViews } from "../core/helpers";
import { initTricksWords } from "../core/helpers";
import { initLazyLoad } from "../core/helpers";
import { playVideoInview } from "../core/helpers";
import { initGoogleTranslate } from "../core/helpers";
//import { initFilter } from "../components/filter";
import { initOpcionesDinamicas } from "../components/filter";
import { initScrolltriggerNav } from "../components/hamburger";
import { initHamburgerNav } from "../components/hamburger";
//import { submenumob } from "../components/hamburger";
import { initSmoothScroll } from "../barba/smoothScroll";
import { initScrolltriggerAnimations } from "../components/scrollAnimations";
import { initSwiper } from "../components/swiper";
import { initMarqueeDrag } from "../components/swiper";
import { initGaleriaMobile } from "../components/swiper";
import { initPopups } from "../components/popups";
import { initOtros } from "../components/otros";
//import { productQuantity } from "../components/otros";
//import { initMapaActividades } from "../components/mapa";

export function initScript() {
  // Utilidad: espera a que la traducción esté aplicada (si corresponde) antes de seguir
 /* function waitForTranslationReady(targetSelector, callback, options = {}) {
    const { quietPeriod = 800, maxWait = 6000 } = options;
    const hasCookiePending = /googtrans=\/[a-z]{2}\/([a-z]{2})/i.test(
      document.cookie,
    );

    // Si el sitio está en español, no hay nada que esperar
    if (!hasCookiePending) {
      callback();
      return;
    }

    const target = document.querySelector(targetSelector) || document.body;
    let finished = false;
    let quietTimer = null;

    const observer = new MutationObserver(() => {
      if (finished) return;
      clearTimeout(quietTimer);
      // Cada vez que hay un cambio, reiniciamos el contador de "silencio"
      quietTimer = setTimeout(finish, quietPeriod);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // Arrancamos el timer ya, por si la traducción terminó antes de que
    // empecemos a observar (poco probable pero posible)
    quietTimer = setTimeout(finish, quietPeriod);

    // Tope máximo por si algo falla (adblock, Google caído, etc.)
    const hardStop = setTimeout(finish, maxWait);

    function finish() {
      if (finished) return;
      finished = true;
      observer.disconnect();
      clearTimeout(quietTimer);
      clearTimeout(hardStop);
      callback();
    }
  }
  waitForTranslationReady("body", function () {
     });*/
    initHelpers();
    // initAnimatedHeadings();
    setOffScreenState();
    animateIn();
    //initLoader();
    //pageTransitionIn();
    //pageTransitionOut();
    initWindowInnerheight();
    initCheckTouchDevice();
    initCookieViews();
    initTricksWords();
    initLazyLoad();
    playVideoInview();

    //initFilter();
    //initOpcionesDinamicas();

    initHamburgerNav();
    //    submenumob();

    initScrolltriggerNav();

    initSmoothScroll();

    // if ($("#mapa-actividades").length) {
    //     initMapaActividades();
    // }
    initScrolltriggerAnimations();
    initPopups();
    initSwiper();
    initMarqueeDrag();
    initGaleriaMobile();
    initOtros();
    //initGoogleTranslate();
    //productQuantity();

}
